export const AUDIO_FILES: Record<string, string> = {
  goal: 'voice-goal', goal1: 'voice-goal-1', goal2: 'voice-goal-2', goal3: 'voice-goal-3', goal4: 'voice-goal-4',
  start: 'voice-start', punchVoice: 'voice-punch', kickVoice: 'voice-kick',
  uppercut: 'voice-uppercut', weaponVoice: 'voice-weapon', hitVoice: 'voice-hit',
  ohMyGod: 'voice-oh-my-god', brutal: 'voice-brutal', noPuedeSer: 'voice-no-puede-ser', fatality: 'voice-fatality',
  punch: 'punch-comic', kick: 'kick-rocket', pipe: 'pipe-clang', plank: 'plank-bonk', bottle: 'bottle-break',
  shotgun: 'shotgun-realistic',
  rocketLaunch: 'bazooka-launch', rocketExplosion: 'bazooka-explosion',
};
export const AUDIO_LABELS: Record<string, string> = {
  start: 'Voz · Inicio', goal: 'Voz · Gol (original)', goal1: 'Relator · Gooooool', goal2: 'Relator · Golaaazo', goal3: 'Relator · Increíble, es goooool', goal4: 'Relator · Gol gol goooool',
  punchVoice: 'Voz · Puñetazo', kickVoice: 'Voz · Patadón',
  uppercut: 'Voz · Uppercut', weaponVoice: 'Voz · Golpe con objeto', hitVoice: 'Voz · Grito',
  ohMyGod: 'Reacción · Omaigad!', brutal: 'Reacción · Brutal!!', noPuedeSer: 'Reacción · No puede ser!!', fatality: 'Jugador explota · Fatality!',
  punch: 'Clip · Impacto cómico', kick: 'Clip · Tiro cohete', pipe: 'Clip · Metal', plank: 'Clip · Madera', bottle: 'Clip · Vidrio',
  shot: 'Balón · Tiro completo', pass: 'Balón · Pase', bounce: 'Balón · Rebote', post: 'Balón · Poste',
  landing: 'Jugador · Aterrizaje', slide: 'Jugador · Barrida', down: 'Jugador · Caída',
  shotgun: 'Arma · Disparo de escopeta',
  rocketLaunch: 'Bazooka · Lanzamiento del misil', rocketExplosion: 'Bazooka · Explosión en llamas',
  endMusic: 'Música · Fin de la partida',
  menuMusic: 'Música · Menú de inicio',
  menuClick: 'Menú · Pulsar botón',
  explosion: 'Explosión de jugador · Sonido 1', explosion2: 'Explosión de jugador · Sonido 2', pickup: 'Efecto · Recoger objeto', horn: 'Gol · Bocina', charge: 'Balón · Carga',
};
for (const [style, label] of Object.entries({ punch: 'Puñetazo', kick: 'Patada', uppercut: 'Uppercut', spin: 'Trompo', slam: 'Planchazo' })) {
  AUDIO_LABELS[`swing:${style}`] = `Ataque · Movimiento de ${label}`;
  AUDIO_LABELS[`impact:${style}`] = `Ataque · Impacto de ${label}`;
}
for (const [kind, label] of Object.entries({ pipe: 'Tubería', plank: 'Viga', bottle: 'Botella', greatsword: 'Espadón colosal', warhammer: 'Martillo de guerra', chair: 'Silla de lucha libre' })) {
  AUDIO_LABELS[`weaponSwing:${kind}`] = `Arma · Golpear con ${label}`;
  AUDIO_LABELS[`weaponThrow:${kind}`] = `Arma · Lanzar ${label}`;
  AUDIO_LABELS[`weaponImpact:${kind}`] = `Arma · Impacto de ${label}`;
  AUDIO_LABELS[`weaponBroken:${kind}`] = `Arma · Rotura de ${label}`;
}
for (const [kind, label] of Object.entries({ short: 'Corto', double: 'Doble', long: 'Largo' })) AUDIO_LABELS[`whistle:${kind}`] = `Silbato · ${label}`;

export interface SavedAudio { id: string; name: string; blob: Blob }

async function audioDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('futbol-fighters-audio', 2);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains('clips')) db.createObjectStore('clips', { keyPath: 'id' });
      if (!db.objectStoreNames.contains('background')) db.createObjectStore('background', { keyPath: 'id' });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error('Cierra las otras pestañas del juego para guardar audios.'));
  });
}
export async function readAudioClips(): Promise<SavedAudio[]> {
  const db = await audioDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const request = db.transaction('clips').objectStore('clips').getAll();
      request.onsuccess = () => resolve(request.result.filter((clip: SavedAudio) => clip && AUDIO_LABELS[clip.id] && clip.blob instanceof Blob && typeof clip.name === 'string'));
      request.onerror = () => reject(request.error);
    });
  } finally { db.close(); }
}
export async function saveAudioClip(id: string, clip: SavedAudio | null): Promise<void> {
  const db = await audioDatabase();
  try {
    await new Promise<void>((resolve, reject) => {
      const transaction = db.transaction('clips', 'readwrite');
      if (clip) transaction.objectStore('clips').put(clip);
      else transaction.objectStore('clips').delete(id);
      transaction.oncomplete = () => resolve();
      transaction.onabort = () => reject(transaction.error);
      transaction.onerror = () => reject(transaction.error);
    });
  } finally { db.close(); }
}

export async function readBackgroundAudio(): Promise<SavedAudio | null> {
  const db = await audioDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const request = db.transaction('background').objectStore('background').get('background');
      request.onsuccess = () => resolve(request.result?.blob instanceof Blob ? request.result : null);
      request.onerror = () => reject(request.error);
    });
  } finally { db.close(); }
}

export async function saveBackgroundAudio(clip: SavedAudio | null): Promise<void> {
  const db = await audioDatabase();
  try {
    await new Promise<void>((resolve, reject) => {
      const store = db.transaction('background', 'readwrite').objectStore('background');
      if (clip) store.put({ ...clip, id: 'background' });
      else store.delete('background');
      store.transaction.oncomplete = () => resolve();
      store.transaction.onabort = () => reject(store.transaction.error);
      store.transaction.onerror = () => reject(store.transaction.error);
    });
  } finally { db.close(); }
}
